export default function Values() {
  const values = [
    {
      icon: 'ri-heart-line',
      text: 'Acreditamos verdadeiramente nas empresas e projetos onde estamos'
    },
    {
      icon: 'ri-line-chart-line',
      text: 'Entregamos resultado e legado com visão de médio e longo prazo'
    },
    {
      icon: 'ri-shield-star-line',
      text: 'Somos confiáveis, respeitosos e desenvolvemos credibilidade acima dos interesses econômicos de curto prazo'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      text: 'Provocamos o "status quo" com soluções disruptivas ou alternativas'
    },
    {
      icon: 'ri-lock-line',
      text: 'Primamos pela segurança e confidencialidade dos negócios'
    },
    {
      icon: 'ri-hand-heart-line',
      text: 'Somos leais e éticos em nossas relações comerciais'
    },
    {
      icon: 'ri-eye-line',
      text: 'Somos transparentes com nossos sócios, associados e colaboradores tendo a meritocracia como principal driver de participação dos resultados'
    }
  ];

  return (
    <section id="values" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Cultura e Valores
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Nossos princípios fundamentais que guiam cada decisão e ação
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-20">
          <div className="bg-white rounded-2xl p-10 shadow-lg">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-eye-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-slate-800 mb-6">Nossa Visão</h3>
            <p className="text-slate-600 text-lg leading-relaxed">
              Sermos reconhecidos pelos nossos parceiros de negócios pelo inquestionável aporte de valor em governança e estratégia, pela qualidade de nosso time e pelo foco em desenvolvimento de relações comerciais duradouras e rentáveis.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-10 shadow-lg">
            <div className="w-20 h-20 bg-slate-800 rounded-full flex items-center justify-center mb-6">
              <i className="ri-compass-3-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-slate-800 mb-6">Nossos Valores</h3>
            <p className="text-slate-600 text-lg leading-relaxed mb-6">
              Princípios que norteiam todas as nossas ações e decisões estratégicas:
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer border border-slate-100">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${value.icon} text-2xl text-teal-600`}></i>
                </div>
                <p className="text-slate-700 leading-relaxed">{value.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
